import { Component, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDropdownConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Idle } from '@ng-idle/core';
import { createAppKit } from '@reown/appkit';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { disconnect, getAccount, reconnect, switchChain } from '@wagmi/core';
import { polygon } from '@wagmi/core/chains';
import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi';
import { ToastrService } from 'ngx-toastr';
import { wagmi_config } from 'src/app/core/config/wagmi_config';
import { AccountService } from 'src/app/services/account.service';
import { ContractIntegrationsService } from 'src/app/services/contract-integrations.service';
import { LoginService } from 'src/app/services/login.service';
import { StorageService } from 'src/app/services/storage.service';
import { polygonAmoy } from 'src/app/shared/helpers/polygonAmoy';
import { environment } from 'src/environments/environment';
import { rpcUrls } from 'src/app/core/config/rpc-transport';
import { watchAccount, watchConnections} from 'wagmi/actions'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, inject } from '@angular/core';

@Component({
    selector: 'app-nav-right',
    templateUrl: './nav-right.component.html',
    styleUrls: ['./nav-right.component.scss'],
    providers: [NgbDropdownConfig],
    standalone: false
})

/**
 * Export Class
 */
export class NavRightComponent implements OnInit, OnDestroy {
  readonly destroyRef = inject(DestroyRef);
    account: any = {};
    connector: any;
    ethereum: any;
    authSubscribe: any;
    regulated = false;
    @Input('collapseStyle') collapseStyle;
    unwatchAccount: any;
    unwatchNetwork: any;
    public web3Modal: any;
    @ViewChild('switchNetworkModal') switchNetworkModal: { show: () => void; hide: () => void; };
    defaultNetwork: any;
    walletProvider: string = '';
    private isLoggingOut: boolean = false;
    private wagmiAdapter: any;

    /**
     * Constructors
     */
    constructor(
        private accountService: AccountService,
        private storageService: StorageService,
        private router: Router,
        private toastr: ToastrService,
        private zone: NgZone,
        private contractIntegrationService: ContractIntegrationsService,
        private modalService: NgbModal,
        private idleService: Idle,
        private loginService: LoginService,
    ) {

    }

    /**
     * Initial Loader
     */
    ngOnInit() {
        this.wagmiConfig();
        this.account = this.storageService.getItem('wagmi_new_store') === null ?
            { address: '', network: '', chainId: '', provider: '' } :
            JSON.parse(this.storageService.getItem('wagmi_new_store') as any);

        this.walletProvider = JSON.parse(this.storageService.getItem('wagmi.connectedRdns') || 'null');

        this.regulated = JSON.parse(this.storageService.getItem('regulated'));

        if (this.regulated != false) {
            this.storageService.setItem('regulated', true);
            this.regulated = JSON.parse(this.storageService.getItem('regulated'));
        }

        setTimeout(() => {
            this.defaultNetwork = environment.SUPPORTED_CHAINS;
        }, 1000);
    }

    /**
      * Wagmis config
      */
    public async wagmiConfig() {
        // wallet connect initialization
        const projectId = environment.WALLET_CONNECT_PROJECT_ID;
        const suppoertedChain = environment.SUPPORTED_CHAINS[0] == '137' ? polygon : polygonAmoy

        const metadata = {
            name: 'Real World',
            description: 'Real World - Market',
            url: environment.WEB_SITE_URL,
            icons: ['https://avatars.githubusercontent.com/u/37784886']
        }
        const customRpcUrls = {
            [`eip155:${environment.SUPPORTED_CHAINS[0]}`]: rpcUrls().map((url: string) => ({ url }))
        }
        this.wagmiAdapter = new WagmiAdapter({ projectId: projectId, networks: [suppoertedChain], chains: [suppoertedChain], customRpcUrls })
        await createAppKit({
            adapters: [this.wagmiAdapter],
            networks: [suppoertedChain],
            metadata: metadata,
            projectId: environment.WALLET_CONNECT_PROJECT_ID,
            features: {
                socials: false,
                email: false
            },
            themeVariables: {
                "--w3m-color-mix": "#063f2dff",
                "--w3m-color-mix-strength": 40,
                "--w3m-accent": "#06402dff",
            }
        })

        // Watch for account changes
        watchAccount(this.wagmiAdapter.wagmiConfig, {
            onChange: (account: any) => {
                console.log(account, "account")
                if (account.isConnected) {
                    const connectedChainId = account.chainId.toString()
                    if (environment.SUPPORTED_CHAINS.includes(connectedChainId)) {
                        this.switchNetworkModal?.hide();
                        const new_wagmi_store =
                        {
                            state: {
                                data: {
                                    account: account.address,
                                    address: account.address,
                                    network: (environment as any)[connectedChainId].CHAIN_NETWORK,
                                    chainId: account.chainId,
                                    provider: (environment as any)[connectedChainId].CHAIN_NETWORK,
                                    chain: {
                                        id: account.chainId.toString(),
                                        unsupported: false
                                    }
                                }
                            }
                        }
                        this.storageService.setItem('wagmi_new_store', JSON.stringify(new_wagmi_store))
                        this.storageService.setItem('wagmi_connected', 'true')
                    } else {
                        this.switchNetworkModal?.show();
                    }
                    // const isSupportedNetwork = environment.DEFAULT_NETWORK == account.chainId.toString() ? false : true
                }
            }
        });

        // Watch for connection (network) changes
        watchConnections(this.wagmiAdapter.wagmiConfig, {
            onChange: (connections) => {
                console.log(connections, "connections")
                if (Array.isArray(connections) && connections.length != 0) {
                    setTimeout(() => {
                        this.modalService.dismissAll();
                        this.getWalletAddress();
                    }, 500);
                } else {
                    this.handleWalletDisconnect();
                }
            }
        })

        await reconnect(this.wagmiAdapter.wagmiConfig).then((isconnect: any) => {
            console.log("Your account is connected : Welcome tpo RealWorld.fi admin")
        });
        await reconnect(wagmi_config);
    }
    /**
     * Destroy
     */
    public ngOnDestroy() {
        // this.unwatchAccount();
        // this.unwatchNetwork();
    }


    /**
     * Gets wallet address
     */
    public async getWalletAddress() {
        this.account = this.storageService.getItem('wagmi_new_store') === null ?
            { address: '', network: '', chainId: '', provider: '' } :
            JSON.parse(this.storageService.getItem('wagmi_new_store') as any);

        const ownerAddress = await this.contractIntegrationService.owner();
        if (this.account.state.data.account != '' && ownerAddress != this.account.state.data.account) {
            this.toastr.error('Owner Address Not Found');
            if (this.wagmiAdapter) {
                await this.revokeInjectedWalletPermissions(this.wagmiAdapter.wagmiConfig);
                await disconnect(this.wagmiAdapter.wagmiConfig);
            }
            this.storageService.clearItem();
            this.zone.run(() => {
                this.router.navigate(['/login']);
            })
        }
    }

    /**
     * wagmi's own disconnect() already asks the wallet to revoke the eth_accounts
     * permission, but bounds that request to a 100ms timeout (some wallets hang
     * on it), so it frequently loses the race and the wallet keeps listing the
     * site as connected. Retry the same request — against the provider bound to
     * the connector that's actually connected, not just `window.ethereum` (which
     * may belong to a different injected wallet, e.g. MetaMask vs. Phantom, when
     * more than one extension is installed) — with a more generous timeout, and
     * do it before disconnect() tears down the connector reference.
     */
    private async revokeInjectedWalletPermissions(config: any): Promise<void> {
        try {
            const connector = getAccount(config)?.connector;
            const provider: any = connector?.getProvider ? await connector.getProvider() : null;
            if (!provider?.request) return;
            await Promise.race([
                provider.request({
                    method: 'wallet_revokePermissions',
                    params: [{ eth_accounts: {} }]
                }),
                new Promise((resolve) => setTimeout(resolve, 3000))
            ]);
        } catch {
            // Not all wallets support this method; ignore failures.
        }
    }

    slideToggle() {
        this.regulated = !this.regulated;
        this.storageService.setItem('regulated', this.regulated);
        window.location.reload();
    }

    /**
     * Wallet disconnected via AppKit modal / extension / etc. Invalidates
     * the server-side session before clearing local state and routing to
     * the login page. Re-entrancy guarded so a 401 from the logout endpoint
     * cannot re-trigger this flow via the HTTP interceptor.
     */
    private handleWalletDisconnect() {
        if (this.isLoggingOut) {
            return;
        }
        this.isLoggingOut = true;

        const cleanup = () => {
            this.idleService.stop();
            this.storageService.clearItem();
            this.account = { address: '', network: '', chainId: '', provider: '' };
            this.accountService.authValidationsUpdate(false);
            this.router.navigate(['/login']);
            this.isLoggingOut = false;
        };

        const token = this.storageService.getItem('token');
        if (token) {
            this.loginService.logout().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
                next: () => cleanup(),
                error: () => cleanup()
            });
        } else {
            cleanup();
        }
    }

    /**
       * Logout (admin clicked the button) — invalidates the session on the
       * server (best-effort) before clearing local state. Re-entrancy guarded
       * so a 401 from the logout endpoint cannot re-trigger this flow via the
       * HTTP interceptor. An expired session is not handled here but in
       * IdleService.handleSessionExpired().
       */
    async logout() {
        if (this.isLoggingOut) {
            return;
        }
        this.isLoggingOut = true;

        const finalize = async () => {
            this.toastr.success('You have been logged out.');
            await disconnect(wagmi_config);
            this.idleService.stop();
            this.storageService.clearItem();
            this.account = { address: '', network: '', chainId: '', provider: '' };
            this.accountService.authValidationsUpdate(false);
            setTimeout(() => {
                this.router.navigate(['/login']);
            }, 1000);
            this.isLoggingOut = false;
        };

        const token = this.storageService.getItem('token');
        if (token) {
            this.loginService.logout().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
                next: () => finalize(),
                error: () => finalize()
            });
        } else {
            await finalize();
        }
    }

    /**
    * Switchs network
    * @param {string} chainId 
    */
    switchNetwork(chainId: string) {
        switchChain(wagmi_config, { chainId: Number(chainId) });
    }

}
